<template>
    <div class="row">
        <div class="col-md-12 card" style="padding-bottom: 20px;">
            <div class="card-header">
                <h4 class="card-title">Country Insights</h4>
                <br />
                <!-- <p><b>This section is only available via a subscription.</b></p> -->
                <p>The Country Insights page shows global information regarding all country turnaround times,
                    fraudulent
                    rates, public holidays and any ongoing event which may impact verification times.</p>
                <div class="card-contact-div">
                    <p><a href="https://www.qualificationcheck.com/contact/" target="_blank"><button
                                class="btn btn-fill pull-right">Contact Us</button></a></p>
                    <p>For more information and to be granted access please contact Qualification Check.</p>
                </div>
                <div id="carousel-container">
                    <h5>Preview:</h5>
                    <div class="card-content carousel-box">
                        <el-carousel :interval="10000" height="60vh" arrows="always" id="carousel">
                            <el-carousel-item v-for="slide in carouselData" :key="slide.i">
                                <br />
                                <p>{{ slide.title }}</p>
                                <hr />
                                <img :src="require(`../CountryInfo/images/${slide.source}.jpg`)" :alt="slide.title + ' information'">
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            carouselData: [
                // {
                //     title: "Global Information",
                //     source: 'country-insights-table',
                // },
                {
                    title: "Country Insights",
                    source: 'country-insights-nigeria',
                },
                {
                    title: "Verification Statistics",
                    source: 'country-insights-verifications',
                },
                {
                    title: "Student Mobility Information",
                    source: 'Country-Insights-Students',
                },
                {
                    title: "Macro-Level Information",
                    source: 'country-insights-macro',
                },
                {
                    title: "Public Holiday Information",
                    source: 'country-insights-public-holidays',
                },
                {
                    title: "Multiple World Map Views",
                    source: 'country-insights-map',
                }
            ]
        }
    }
}

</script>
<style lang="scss" scoped>

#carousel {
    height: 60vh
}

#carousel-container {
    margin-bottom: 10px;
}

.carousel-box {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 0px 5px;
    margin-bottom: 20px;
    max-width: 1600px;
    margin: auto;
}

.card-contact-div {
    margin-top: 20px;
}

@media only screen and (max-width: 1400px) {
    #carousel {
        height: auto;
        max-height: 50vh;
        overflow-y: hidden;
    }
}
@media only screen and (max-width: 1000px) {
    .card-contact-div {
        padding-bottom: 20px;
    }
}

@media only screen and (max-width: 700px) {
    .card-contact-div {
        display: block;
        padding-bottom: 20px;
        max-height: 20vh; 
    }
    #carousel {
        max-height: 40vh; 
    }
    .carousel-box {
        max-height: 45vh;
    }
}
</style>


